var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLooseWeight = function SvgLooseWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7EEC01",
    d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0m0 2.5a.5.5 0 0 0-.5.5v4.793L4.354 6.646a.5.5 0 1 0-.708.708L6 9.707l2.354-2.353a.5.5 0 1 0-.708-.708L6.5 7.793V3a.5.5 0 0 0-.5-.5"
  })));
};
export default SvgLooseWeight;